import { HttpInterceptorFn } from '@angular/common/http';
import { apiUrl } from './api-url';

export const apiUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (/^https?:\/\//i.test(req.url)) {
    return next(req);
  }

  const path = req.url.replace(/^\/api\/v1\/?/, '').replace(/^\//, '');
  return next(req.clone({ url: apiUrl(path) }));
};
